import React from 'react'
import './styles.scss'

export default function SectionHeader(props) {
  const {subTitle,TitleclassName, className,children,subTitleClassName} = props
  return (
    <>
    <div className={`${className} sectionheader`}>
      {children}
    </div>
    </>
  )
}
